import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';

import PbxContext from '../../../context/PbxContext';
import { accessLocalStorage, readAllTenant, listFilesUploaded, sendDataMohUpdate, exportSelectMohsByName } from '../../../services';
import { scopeByTenant } from '../../../services/tenantScope';

import Loading from '../../../components/Loading/LoadingModule';
import './MohForm.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faTimes } from '@fortawesome/free-solid-svg-icons';

function MohEdit() {
  const getItensStateGlobal = useContext(PbxContext);
  const { itemsSelectedToEdit } = getItensStateGlobal;

  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [values, setValues] = useState({
    name: "",
    mode: "",
    directory: "",
    accountcode: "",
    sort: "",
  });
  const [originalName, setOriginalName] = useState("");
  const [disableButton, setDisableButton] = useState(true);
  const [disableMusic, setDisableMusic] = useState(true);
  const [tenants, setTenants] = useState([]);
  const [moh, setMohData] = useState({ name: '', tenant: '' });
  const [musicSelected, setMusicSelected] = useState([]);
  const [alert, setAlert] = useState({ show: false, type: '', message: '' });

  const fetchTenants = async (idtenant) => {
    try {
      let tenantsFetched = await readAllTenant();
      tenantsFetched = scopeByTenant(tenantsFetched, (tenant) => tenant.short_name, idtenant);
      if (!tenantsFetched) return;
      setTenants(tenantsFetched);
    } catch (error) {
      console.error("Erro ao buscar tenants:", error);
    }
  };

  const validateUserLogged = useCallback(async () => {
    try {
      const dataUser = accessLocalStorage.getUserLocalStorage();
      if (!dataUser) return history.push('/');

      const { user: { idtenant } } = dataUser;

      if (!itemsSelectedToEdit || itemsSelectedToEdit.length === 0) {
        return history.push('/config/musica-de-espera/lista');
      };

      await fetchTenants(idtenant);
      const fetchMohData = await exportSelectMohsByName(itemsSelectedToEdit);

      if (fetchMohData.status !== 200) return history.push('/config/musica-de-espera/lista');
      const received = fetchMohData.data;

      setOriginalName(itemsSelectedToEdit);

      const accountcode = received.accountcode || '';
      const shortName = (received.name || '')
        .replace(/^moh-/, '')
        .replace(new RegExp(`-${accountcode}$`), '');

      let musicFile = '';
      if (received.mode === 'playlist' && received.music) {
        musicFile = received.music.split('/').pop().split('.')[0];
      }

      const initialValues = {
        name: shortName,
        mode: received.mode || '',
        directory: received.directory || '',
        accountcode,
        sort: received.sort || '',
      };
      if (received.mode === 'playlist') initialValues.music = musicFile;

      setValues(initialValues);
      if (received.mode === 'playlist') setDisableMusic(false);

      const uploadedFiles = await listFilesUploaded();
      setMohData(uploadedFiles);
      const filesOfTenant = uploadedFiles && uploadedFiles[accountcode] ? uploadedFiles[accountcode].moh : [];
      setMusicSelected(Array.isArray(filesOfTenant) ? filesOfTenant : []);

      setLoading(false);
    } catch (error) {
      console.error("Erro ao carregar dados:", error);
      history.push('/config/musica-de-espera/lista');
    }
  }, [history, itemsSelectedToEdit]);

  const valuesAnalyse = (data) => {
    const { name, accountcode, mode, sort, music } = data;
    const requiredFieldsFilled = name.length > 0 && accountcode.length > 0 && mode.length > 0 && sort.length > 0;
    const musicFilled = mode !== 'playlist' || !!music;
    setDisableButton(!(requiredFieldsFilled && musicFilled));
  };

  const handleChangeValues = (item) => {
    const { name, value } = item;

    if (name === 'mode' && value === 'files') setDisableMusic(true);
    if (name === 'mode' && value === 'playlist') setDisableMusic(false);
    if (name === 'accountcode') moh.hasOwnProperty(value) ? setMusicSelected(moh[value].moh) : setMusicSelected([]);

    setValues((prevState) => {
      const setRealValues = { ...prevState, [name]: value };
      if (name === 'mode' && value === 'files') delete setRealValues.music;
      valuesAnalyse(setRealValues);
      return setRealValues;
    });
  };

  const analyseDataMohPreSend = () => {
    const payload = { ...values, name: `moh-${values.name}-${values.accountcode}`, originalName };
    if (payload.mode === 'files') payload.directory = `/opt/vigoscloud/api/uploads/moh/${payload.accountcode}`;
    if (payload.mode === 'playlist') {
      payload.entry = `/opt/vigoscloud/api/uploads/moh/${payload.accountcode}/${payload.music}`;
      payload.position = 0;
      payload.directory = '';
    }
    return payload;
  };

  const handleSubmit = async () => {
    setSaving(true);
    setAlert({ show: false, type: '', message: '' });

    try {
      const result = await sendDataMohUpdate(analyseDataMohPreSend());

      if (result.success) {
        setAlert({ show: true, type: 'success', message: 'Música de espera atualizada com sucesso!' });
        setTimeout(() => {
          history.push('/config/musica-de-espera/lista');
        }, 2000);
        return;
      }

      setAlert({ show: true, type: 'danger', message: result.error });
    } finally {
      setSaving(false);
    }
  };

  useEffect(() => {
    validateUserLogged();
  }, [validateUserLogged]);

  useEffect(() => {
    if (values) {
      valuesAnalyse(values);
    }
  }, [values]);

  return (
    <div>
      {loading ? (
        <Loading />
      ) : (
        <div className="moh-form-container">
          <div className="moh-form-header">
            <div className="moh-form-title-wrapper">
              <svg className="moh-form-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19V6l12-3v13M9 19c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zm12-3c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zM9 10l12-3" />
              </svg>
              <div>
                <h1 className="moh-form-title">Editar Música de Espera</h1>
                <p className="moh-form-subtitle">Atualize as configurações da música de espera</p>
              </div>
            </div>
          </div>

          {alert.show && (
            <div className="alerts-section">
              <div className={`alert-message alert-${alert.type}`}>
                <div className="alert-header">
                  <span>{alert.type === 'success' ? 'Sucesso!' : 'Erro!'}</span>
                  <button className="alert-close" aria-label="delete" onClick={() => setAlert({ show: false, type: '', message: '' })}>×</button>
                </div>
                <div className="alert-body">{alert.message}</div>
              </div>
            </div>
          )}

          <form name="edit-form" id="edit-form" onSubmit={(e) => e.preventDefault()}>
            <div className="form-card">
              <div className="form-row">
                <div className="form-field">
                  <label className="form-label">Nome</label>
                  <div className="form-control">
                    <input
                      className="form-input"
                      name="name"
                      type="text"
                      value={values.name}
                      onChange={(e) => handleChangeValues(e.target)}
                      placeholder="Insira o nome da música de espera"
                    />
                  </div>
                </div>

                <div className="form-field">
                  <label className="form-label">Cliente</label>
                  <div className="form-control">
                    <select
                      className="form-select"
                      name="accountcode"
                      value={values.accountcode}
                      onChange={(e) => handleChangeValues(e.target)}
                    >
                      <option value="">Selecione</option>
                      {tenants.map((tenant) => (
                        <option key={`${tenant.accountcode}-${tenant.name}`} value={tenant.short_name}>
                          {tenant.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

              <div className="form-row">
                <div className="form-field">
                  <label className="form-label">Tipo</label>
                  <div className="form-control">
                    <select
                      className="form-select"
                      name="mode"
                      value={values.mode}
                      onChange={(e) => handleChangeValues(e.target)}
                    >
                      <option value="">Selecione</option>
                      <option value="files">Ler Pasta</option>
                      <option value="playlist">Música Única</option>
                    </select>
                  </div>
                </div>

                <div className="form-field">
                  <label className="form-label">Ordenar</label>
                  <div className="form-control">
                    <select
                      className="form-select"
                      name="sort"
                      value={values.sort}
                      onChange={(e) => handleChangeValues(e.target)}
                    >
                      <option value="">Selecione</option>
                      <option value="name">Nome</option>
                      <option value="random">Aleatório</option>
                    </select>
                  </div>
                </div>

                <div className="form-field">
                  <label className="form-label">Música</label>
                  <div className="form-control">
                    <select
                      className="form-select"
                      name="music"
                      value={values.music || ""}
                      onChange={(e) => handleChangeValues(e.target)}
                      disabled={disableMusic}
                    >
                      <option value="">Selecione</option>
                      {musicSelected.map((music) => (
                        <option key={music} value={music.split('.')[0]}>
                          {music.split('.')[0]}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

              <div className="form-actions">
                <Link to="/config/musica-de-espera/lista" className="btn-cancel">
                  <FontAwesomeIcon icon={faTimes} />
                  Cancelar
                </Link>
                <button
                  className="btn-submit"
                  onClick={handleSubmit}
                  disabled={disableButton || saving}
                >
                  <FontAwesomeIcon icon={faSave} />
                  {saving ? 'Salvando...' : 'Salvar Alterações'}
                </button>
              </div>
            </div>
          </form>
        </div>
      )}
    </div>
  );
}

export default MohEdit;
